import { createReducer, on } from '@ngrx/store';
import * as VehiclePhotoActions from '../actions/vehicle-photo.actions';
import { VehicleAttachmentModel } from '@fc-vehicles/models/vehicle-attachment-model';

export const vehiclePhotoFeatureKey = 'vehiclePhoto';

export interface PhotoPlaceholder {
  name?: string;
  description?: string;
  vehicle?: number;
  photo?: string;
}

export interface State {
  vehiclePhotos: VehicleAttachmentModel[];
  photoPlaceholders: PhotoPlaceholder[];
  tempPhotos: any[];
  loading: boolean;
}

export const initialState: State = {
  vehiclePhotos: [],
  photoPlaceholders: [],
  tempPhotos: [],
  loading: false,
};

export const reducer = createReducer(
  initialState,

  on(
    VehiclePhotoActions.loadVehiclePhotos,
    (state): State => ({
      ...state,
      loading: true,
      vehiclePhotos: [],
    }),
  ),
  on(VehiclePhotoActions.loadVehiclePhotosSuccess, (state, action) => ({
    ...state,
    vehiclePhotos: action.photos,
    loading: false,
  })),
  on(
    VehiclePhotoActions.loadVehiclePhotosFailure,
    (state): State => ({
      ...state,
      photoPlaceholders: [],
      loading: false,
    }),
  ),
  on(VehiclePhotoActions.deleteVehiclePhotoSuccess, (state, action) => ({
    ...state,
    vehiclePhotos: state.vehiclePhotos.filter(
      (photo) => photo.id !== action.photo.id,
    ),
  })),
  on(
    VehiclePhotoActions.deleteSelectedVehiclePhotosSuccess,
    (state, action) => ({
      ...state,
      vehiclePhotos: state.vehiclePhotos.filter(
        (photo) => !action.photos.map((i) => i.id).includes(photo.id),
      ),
    }),
  ),
  on(VehiclePhotoActions.updateVehiclePhotoSuccess, (state, action) => {
    const vehiclePhotos = state.vehiclePhotos.map((photo) =>
      photo.id === action.photo.id
        ? action.photo
        : Object.keys(action.fields).includes('isPrimary')
          ? {
              ...photo,
              isPrimary: false,
            }
          : photo,
    );
    return {
      ...state,
      vehiclePhotos,
    };
  }),
  on(VehiclePhotoActions.uploadVehiclePhoto, (state, action) => ({
    ...state,
    loading: true,
    photoPlaceholders: action.sources.map((photo) => ({
      photo: photo.photo,
      description: photo.description,
      vehicle: action.vehicleId,
    })),
  })),
  on(
    VehiclePhotoActions.uploadVehiclePhotoSuccess,
    (state, action): State => ({
      ...state,
      vehiclePhotos: [...state.vehiclePhotos, ...action.photos],
      photoPlaceholders: [],
      loading: false,
    }),
  ),
  on(VehiclePhotoActions.addTempPhotos, (state, action) => ({
    ...state,
    tempPhotos: action.photos,
  })),
);

export const getVehiclePhotos = (state: State) => state.vehiclePhotos;
export const getPhotoPlaceholders = (state: State) => state.photoPlaceholders;
export const getVehiclePhotosLoading = (state: State) => state.loading;
export const getTempPhotos = (state: State) => state.tempPhotos;
